import React, { JSX } from 'react';
import {
  Text,
  RichText,
  Field,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';
import { ItemValue } from 'components/types/ListItem';

type IntroSectionProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    Heading: Field<string>;
    Description: RichTextField;
    TextAlignment: ItemValue;
    BackgroundColor: ItemValue;
  };
};

const IntroSection = (props: IntroSectionProps): JSX.Element => {
  if (!props || !props.fields) {
    return <div></div>;
  }
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;
  const hasBg = !!fields.BackgroundColor?.name;

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`intro-section-${props.rendering?.uid}`}
    >
      <div className="intro-section">
        <div
          className={classNames(
            hasBg ? `with-bg ${fields.BackgroundColor.name}` : ''
          )}
        >
          <div className="content-wrapper jss-inner-container">
            <div
              className={classNames(
                'inner-content',
                fields.TextAlignment?.name
                  ? fields.TextAlignment.name.toLowerCase() === 'centered'
                    ? 'text-center'
                    : ''
                  : ''
              )}
            >
              {fields?.Heading?.value && (
                <Text tag="h2" className="headline" field={fields?.Heading} />
              )}
              {fields?.Description?.value && (
                <div className="text-content">
                  <RichText
                    className="osf-intro-copy"
                    field={fields?.Description}
                    tag="p"
                  ></RichText>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSection;
